import { CSSProperties, MouseEventHandler } from "react";
import { LinkButton } from "./Button";
import { classNames } from "../utils/classNames";

export interface SortedHeadCellProps {
  label: string;
  align?: "left" | "center" | "right";
  onClick: MouseEventHandler<HTMLSpanElement>;
  direction?: "asc" | "desc";
  active?: boolean;
  style?: CSSProperties;
  tooltipLabel?: string;
  linkClassName?: string;
}

export function SortedHeadCell({
  label,
  align,
  onClick,
  direction,
  active,
  style,
  tooltipLabel,
  linkClassName,
}: SortedHeadCellProps) {
  return (
    <th
      align={align || "right"}
      style={style}
      className={
        align === "left" ? "tw-text-left" : align === "center" ? "tw-text-center" : "tw-text-right"
      }
    >
      <LinkButton
        icon={(active || undefined) && (direction === "asc" ? "arrow-up" : "arrow-down")}
        size={"sm"}
        color={"inherit"}
        underline={false}
        onClick={onClick}
        label={label}
        aria-label={tooltipLabel}
        data-tooltip={tooltipLabel}
        className={classNames(linkClassName, "whitespace-nowrap")}
      />
    </th>
  );
}
